<template>
  <div class="section">
    <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
      <div class="columns">
        <div class="column is-8-tablet is-offset-2-tablet">
          <div class="block">
            <div class="columns">
              <div class="column set-height">
                <h4 class="title is-3">Neuer Nutzer</h4>
              </div>
            </div>
            <div class="box">
              <div class="columns">
                <div class="column is-2">
                  <BInputWithValidation
                    rules="required|max:10"
                    type="text"
                    label="Anrede"
                    v-model="user.salutation"
                  />
                </div>
                <div class="column">
                  <BInputWithValidation
                    rules="required|max:50"
                    type="text"
                    label="Vorname"
                    v-model="user.first_name"
                  />
                </div>
                <div class="column">
                  <BInputWithValidation
                    rules="required|max:50"
                    type="text"
                    label="Nachname"
                    v-model="user.last_name"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <BInputWithValidation
                    rules="required|email|max:100"
                    type="email"
                    label="E-Mail"
                    v-model="user.email"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <BInputWithValidation
                    rules="max:100"
                    type="text"
                    label="Abteilung"
                    v-model="user.department"
                  />
                </div>
                <div class="column">
                  <BInputWithValidation
                    :rules="{ max: 15, regex: /^\+?[0-9][0-9\s-]+[0-9]$/ }"
                    type="text"
                    label="Telefon"
                    v-model="user.phone"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <BSelectWithValidation
                    rules="required|oneOf:admin,org_admin,user"
                    label="Nutzer Typ"
                    v-model="user.type"
                    expanded
                  >
                    <option value="admin">Admin</option>
                    <option value="user">User</option>
                    <option value="org_admin">Org. Admin</option>
                  </BSelectWithValidation>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <BSelectModalWithValidation
                    label="Organisation"
                    v-model="user.org_id"
                    rules="required"
                    :displayValue="theOrg(user.org_id).name"
                    :data="orgs"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <BCheckbox
                    label="Organisation"
                    v-model="user.send_activation">
                    Aktivierungs-Email senden
                  </BCheckbox>
                </div>
                <div class="column">
                  <BCheckbox
                    label="Organisation"
                    v-model="user.send_activation_copy"
                    :disabled="!user.send_activation">
                    Kopie an {{ me.email }} senden
                  </BCheckbox>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column is-6 is-offset-3">
              <b-button
                type="is-gold"
                :disabled="invalid"
                @click="handleSubmit(submit)"
                expanded
              >
                Nutzer erstellen
              </b-button>
            </div>
          </div>
          <div class="block" v-if="error">
            <b-message type="is-danger">
              <span v-html="error" />
            </b-message>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';
import BSelectWithValidation from '@/components/inputs/BSelectWithValidation.vue';
import BSelectModalWithValidation from '@/components/inputs/BSelectModalWithValidation.vue';

export default {
  name: 'NewUser',
  components: {
    BInputWithValidation,
    BSelectWithValidation,
    BSelectModalWithValidation,
  },
  data() {
    return {
      user: {
        first_name: '',
        last_name: '',
        salutation: '',
        email: '',
        department: '',
        phone: null,
        org_id: null,
        type: 'user',
        send_activation: false,
        send_activation_copy: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'user/me',
      users: 'user/data',
      error: 'user/error',
      orgs: 'org/data',
      theOrg: 'org/dataById',
    }),
  },
  methods: {
    submit() {
      this.$store.dispatch('user/CREATE', this.user);
    },
  },
};
</script>

<style lang="scss" scoped>
.is-inactive {
  color: rgb(184, 184, 184);
  &:hover {
    color: hsl(0, 0%, 62%);
  }
}
</style>
<style>
</style>
